define([
	'require',
	'jquery',
	'pubsub',
	'wcs.context',
	'wcs.utils',
	'wcs.alert',
	'wcs.product-form-core',
	'wcs.product-form-util',
	'wcs.product-form-data-extract'
], function( require, $, pubsub, ctx, utils, dialogAlert, ProductForm, utill, dataExtract ) {

	var DEBUG = false,
		PLUGIN_IDENTIFIER = "AddToCartForm",
		token = utils.getURLParam(window.location.href, 'token'),
		isRedeemGiftPdp =  ($('.product-form-js').data('redeem-gift-enabled') && token.length > 0), /*VFDP-44279: Add change for redeem gift/egiftcard on PDP*/
		unmadeEditorOptions,
		currentDesignId;

	var AddToCart = function (productForm) {

		if (!(this instanceof AddToCart)) {
			return new AddToCart(productForm);
		}

		this.productForm = $(productForm);

		return this;

	};

	AddToCart.prototype = {

		initAddToCart : function () {

			var self = this;
			this.unbindAddToCartEvents();
			this.initAddToCartEvents();
			this.initProductFormCore();
			this.initRedeemAGift();
			this.initProductAuthentication();
			this.initAddToWishListClass();
			this.initGlobalEvent();

			if( this.skuAuthenticationEnabled ) {
				$.pubsub('subscribe', 'WCS.PRODUCTFORM.COLOR.ITEM.AVAILABILITY', function (msg, data) {
					if (data.itemKey) {
						try {
							self.currentCatEntry = parseInt(data.itemKey);
							if( data.isClicked) {
								self.selectedCatEntry = self.currentCatEntry;
								self.lastEventHover = false;
							}
							else {
								self.lastEventHover = true;
							}
							self.initAuthenticationRequiredSwatch();
						} catch (exc) {
							console.error('Cannot parse cat entry');
						}
					}
				});
			}

			return this;
		},

		initProductAuthentication: function() {
			this.isAuthenticated = false;
			var $colorSwatch =  $('.attr-box.selected > .color-swatch-button-content');
			var data = $colorSwatch.data();
			if( !data ||  data.authenticatedOnlyAddToCart !== ''){ // Check for presence of an attribute, if not - do not initialize at all the authentication
                return;
            }

			this.skuAuthenticationEnabled = $colorSwatch.closest('.product-content-form-attr-container').data().skuLevelAuthenticationEnabled === '';
			this.$addToCartButton = this.productForm.find('.add-to-bag-js');
			this.$signInButton = this.productForm.find('.sign-in-button');
			this.signInCookieName = this.$signInButton.data('signInCookieName');
			this.signInCookieValidValue = this.$signInButton.data('signInCookieValidValue') || 'full';
			this.initAuthenticationRequiredSwatch();
			$.pubsub('subscribe', 'product-form.attr.swatch.click', this.initAuthenticationRequiredSwatch.bind(this));
			if (this.skuAuthenticationEnabled) {
				$.pubsub('subscribe', 'WCS.PRODUCTFORM.EVENT.ATTR.MOUSE.LEAVE', this.focusOut.bind(this));
			}
		},

		focusOut: function() {
			var self = this;
			self.currentCatEntry =  self.selectedCatEntry;
			this.initAuthenticationRequiredSwatch();
		},

		initAuthenticationRequiredSwatch: function() {
			var $activeColorSwatch = $('.attr-box.selected > .color-swatch-button-content');
			this.checkLoyaltyCookie();
			var requireAuthentication = this.skuAuthenticationEnabled !== true; // If sku authentication is not enabled, then it is on product level, so it should be true

			if (this.currentCatEntry && this.productAvailJSON.skuPreSale && this.productAvailJSON.skuPreSale.skus && this.productAvailJSON.skuPreSale.skus.length > 0) {
				if( this.productAvailJSON.skuPreSale.skus.indexOf(this.currentCatEntry) > -1 ) {
					requireAuthentication = true;
				}
			}
			if( $activeColorSwatch.data().authenticatedOnlyAddToCart === '' && requireAuthentication){
				this.authenticateOnlyEnabled = true;
				this.changeAddButtonAuthenticationStatus();
				if(!this.isAuthenticated){
					$(document).off('closed.zf.reveal.pdp.presale');
					$(document).on('closed.zf.reveal.pdp.presale', this.authenticationModalClosed.bind(this));
				}
			} else {

				if (this.authenticateOnlyEnabled) {
					this.authenticateOnlyEnabled = null;
					this.changeAddButtonAuthenticationStatus();
				}
			}
		},

		checkLoyaltyCookie: function() {
			this.isAuthenticated = false;
			var cookie = ctx.getCookie(this.signInCookieName);
			if( cookie && cookie === this.signInCookieValidValue ){
				this.isAuthenticated = true;
			}
		},

		authenticationModalClosed: function() {
			this.checkLoyaltyCookie();
			this.changeAddButtonAuthenticationStatus();
			if( this.isAuthenticated ){
				$(document).off('closed.zf.reveal.pdp.presale');
				this.$addToCartButton.trigger('click'); // In case of successful login - trigger add to cart
			}
		},

		changeAddButtonAuthenticationStatus: function() {

			if( this.isAuthenticated || !this.authenticateOnlyEnabled ){ //Restore back add to cart button
				this.toggleSignInVisibility(false);
			}
			else {
				this.toggleSignInVisibility(true);
			}
		},

		 toggleSignInVisibility: function(hideAddToCart) {
			if( hideAddToCart ){
				this.$addToCartButton.hide(); // Intentionally used hide because other functionality (hover for example) are removing the hide class
				if( "R" === ctx.getUserType() ){ // swap out url if non member when available
					var url = this.$signInButton.data('authenticatedNonMemberUrl');
					if(url != null && url.length > 0){
						this.$signInButton.data('openAjax', url);
					}
				}
				this.$signInButton.removeClass('hide');
				$.pubsub('publish', 'WCS.PRODUCTFORM.EVENT.SIGNIN.VISIBILITY.CHANGE', {signInVisible: true, wasHover: this.lastEventHover});
			}
			else {
				this.$addToCartButton.show();
				this.$signInButton.addClass('hide');
				$.pubsub('publish', 'WCS.PRODUCTFORM.EVENT.SIGNIN.VISIBILITY.CHANGE', {signInVisible: false, wasHover: this.lastEventHover});
			}
		 },

		initRedeemAGift : function () {
			if ( DEBUG ) console.log('initRedeemAGift');
			/*VFDP-44279: Add change for redeem gift/egiftcard on PDP*/
			if (isRedeemGiftPdp) {
				var $addToCartButton = this.productForm.find('.add-to-bag-js'),
				    btnGetThisGiftText = $addToCartButton.data('get-this-gift-text' ),
					egc_url = utils.getURLParam(window.location.href, 'egc_url'),
					pdpElementsToHideArray= [
						'.find-store-js',
						'.product-content-info-write-review-link',
						'.product-content-info-see-product-details-link',
						'.product-content-info-rating',
						'.give-as-gift-link',
						'.product-loyalty-member-container',
						'.egift-link-tooltip'
					],
					$pdpProductInfoElementsToHide=$(pdpElementsToHideArray.join()),
					$pdpRedeemGiftElementsToShow=$('.product-gift-action-get-egift-card-js');
				$pdpProductInfoElementsToHide.addClass('hidden');
				$pdpRedeemGiftElementsToShow.removeClass('hidden');
				if (egc_url.length > 0 ) {
					$('.product-gift-action-get-egift-card-js').attr('href', decodeURIComponent(egc_url));
				}

				$addToCartButton.removeClass('disabled btn-out-of-stock').text(btnGetThisGiftText);
				$('.product-actions-primary').addClass('product-redeem-as-gift-container'); //adding class to target styling
			}
		},

		unbindAddToCartEvents : function () {

			$.pubsub('unsubscribe', this.updateItemSelectionInStockEventToken);
			$.pubsub('unsubscribe', this.addToCartItemSelectionInStockEventToken);
			$.pubsub('unsubscribe', this.addToWishListMessaging);

			this.productForm.find('.add-to-bag-js').off('click', this.handleAddToBagClick);
			this.productForm.off('submit', this.handleAddToBagClick);

		},

		initAddToCartEvents : function () {

			var self = this;

            this.productForm.find('.add-to-bag-js').on('click', {self:this}, utils.debounce(function(event) {
                self.handleAddToBagClick(event);
            }, 500, true));
			this.productForm.on('submit', {self: this}, this.handleAddToBagClick);

			this.storeSelectionModalAddToCartEvent = $.pubsub('subscribe', 'vfdp.wcs.product_form.add_to_bag_from_store_selection', function(msg, data){
				// expected data : {'addToCartForPickup':true, 'selectedStore': this.selectedStore}
				self.addToCartForPickUp = data.addToCartForPickup;
				self.selectedStore = data.selectedStore;
				self.productForm.find('.add-to-bag-js').trigger('click');
			});

		},

		//
		// Add to bag methods
		handleAddToBagClick : function (event) {

			if ( DEBUG ) console.log('handleAddToBagClick');

			var self = event.data.self,
				$addToCartBtn  = self.productForm.find('.add-to-bag-js'),
				$prdOutOfStock = self.productForm.find('.out-of-stock'),
				isValidForm    = self.isValidForm();

			event.preventDefault();

			if( $addToCartBtn.hasClass('notify-me-active') ) { // if clicked Notify Me Button
				require(["wcs.product-form-notify"], function() {
					self.productForm.closest(".product-content-form").NotifyMe();
					$.pubsub('publish', 'WCS.PRODUCTFORM.EVENT.NOTIFYME.ACTIVE');
				});
                return;

			} else if ( $addToCartBtn.hasClass('bfd-active') ) { // if clicked Buy From An Online Dealer Button
				$.pubsub('publish', 'WCS.PRODUCTFORM.EVENT.ONLINEDEALER.ACTIVE');
				return;
			}

			if ( $addToCartBtn.hasClass('disabled') ) {
				return;
			}

			if ( !isValidForm ){
				return;
			}

			if ( !$('#uclw').length ){
				self.addToBag(event);
				return;
			}

			if ( self.selectChangeComplete === true && $('#uclw').length && $('#uclw').is(':visible') ){
				self.addToBag(event);
				self.selectChangeComplete = false;
				return;
			} else {
				setTimeout( function(){
					self.productForm.find('.add-to-bag-js').trigger('click');
				}, 100);
			}

		},

		addToBag: function(event) {

			if ( DEBUG ) console.log('addToBag');

			var self 	  = event.data.self,
				dataObj   = self.buildDataObjectForValidAddToBag(),
				action = currentDesignId ? "VFAjaxCustomOrderItemAdd" : "VFAjaxOrderItemAdd";
				actionUrl = ctx.getContextRoot() + action;

			//Notify other processes

			$.pubsub('publish', 'vfdp.wcs.product_form.add_to_cart_clicked');

			self.submitForm(dataObj, actionUrl, function(response){

				self.handleFormSubmitResponse(response);

			});

		},

		buildDataObjectForValidAddToBag : function () {

			if ( DEBUG ) console.log('buildDataObjectForValidAddToBag');

			var self = this;

			var dataObj = {};

			// PDP advanced checkout - if delivery option is set to pick-up or instance property set by event for pick up, then send storeID as param
			if ( this.addToCartForPickUp || this.stateManager.getProperty('deliveryOption') === 'pick-up' ) {
				dataObj.physicalStoreIdentifier = this.selectedStore || this.stateManager.getProperty('selectedStore');
				this.addToCartForPickUp = false;
				this.selectedStore = null;
			}

            // For unisex products we should also send the department in the dataObj
            if (self.addToCartButton.data('department')) {
                dataObj.department = self.addToCartButton.data('department');
			}

			dataObj.categoryId 	= self.categoryId;
			dataObj.storeId 	= self.storeId;
			dataObj.langId 		= self.langId;
			dataObj.catalogId 	= self.catalogId;
			dataObj.orderId 	= '.';
			dataObj.URL 		= '/';

			// when cross-sell item is selected add it to the list of products to be added to the bag
			var $crossSellItem = self.productForm.find('#crossSellCheckbox');
			if ($crossSellItem.length > 0 && $crossSellItem.is(':checked')) {
				dataObj.catEntryId_1 = self.catEntryId;
				dataObj.quantity_1 	 = $.productFormUtil.getQuantity(self.productForm);
				dataObj.catEntryId_2 = $crossSellItem.val(); // cross-sell item
				dataObj.quantity_2   = "1"; // cross-sell qty
			} else {
				dataObj.catEntryId = self.catEntryId;
				dataObj.quantity = $.productFormUtil.getQuantity(self.productForm);
			}

			// For custom product adding couple of extra params to dataObj.
			unmadeEditorOptions = $('.product-content-form-customise-btn').data('unmadeEditorOptions');
			currentDesignId = unmadeEditorOptions ? unmadeEditorOptions.currentDesignId : null;

			if(currentDesignId) {
				dataObj.extRecipeId	= currentDesignId;
				dataObj.action 		= 'add';
				dataObj.mergeItems	= false;
				dataObj.imageURL 	=  unmadeEditorOptions ? unmadeEditorOptions.imageUrl: null;
				dataObj.recipeJson 	= unmadeEditorOptions ? unmadeEditorOptions.recipeJson: null;
			}

			return dataObj;

		},

		handleFormSubmitResponse : function (response) {

			if ( DEBUG ) console.log('handleFormSubmitResponse, response : ', response);

			if (response.orderId){

				if (isRedeemGiftPdp) {
					var dataObj = {},
						giftRedemptionData = this.productForm.data('gift-redemption'),
						actionUrl = this.productForm.find('.add-to-bag-js').data('apply-gift-card-url'),
						successUrl = this.productForm.find('.add-to-bag-js').data('gift-success-url');

					if (giftRedemptionData) {
						dataObj.orderId = response.orderId[0];
						dataObj.billingGiftCardNumber = giftRedemptionData.egc.egc_number;
						dataObj.billingGiftCardPIN = giftRedemptionData.egc.access_code;
						dialogAlert.showLoadingNotification('p');
						$.ajax({
							type: "POST",
							url: actionUrl,
							data: dataObj,
							dataType: "json"
						}).done(function (data) {
							dialogAlert.hideLoadingNotification();
							if (data.errorMessage) {
								$.productFormUtil.displayErrorMessage(data.errorMessage, this.productForm);
								dialogAlert.hideLoadingNotification();
							} else {
								window.location.href = successUrl;
							}
						}).fail(function (err) {
							$.productFormUtil.displayErrorMessage(err, this.productForm);
							dialogAlert.hideLoadingNotification();
						});
					} else {
						$.productFormUtil.displayErrorMessage(LANG_MSG.ERR_INVALID_GIFT_CARD_INFO, this.productForm);
					}

				} else {
					$.productFormUtil.clearAddTOCartErrorMessage(this.productForm);

					$.pubsub('publish', 'ORDER_ID_UPDATED', {orderId: response.orderId});

					var productFormIndex = $('.product-form-js').index(this.productForm);
					$.pubsub('publish', 'vfdp.wcs.product_form.add_to_cart_succeeded', {productFormIndex: productFormIndex});

					var $bundleInfo = this.productForm.parents(".bundle-product-info-js"),
						productNameStr,
						catEntryReponse,
						itemId = this.productForm.data('child-part-number'),
						bundleId = this.productForm.data('bundle-part-number').toString(),
						productId = this.productForm.data('product-part-number'),
						$crossSellItem = this.productForm.find('#crossSellCheckbox'),
						volume,
						quantity,
						disableMiniCart = ($('body').data('disableMiniCart')) ? true : false;

					if($bundleInfo.length > 0){ //bundle
						productNameStr = $bundleInfo.find(".product-info-js").data("catentry-name-dl");
					} else { //PDP or QuickView
						productNameStr = $("#product-info .product-info-js:not(.hide)").data("catentry-name-dl");
					}

					if ($crossSellItem.length > 0 && $crossSellItem.is(':checked')) {
						catEntryReponse = response.catEntryId_1[0];
					}else {
						catEntryReponse = response.catEntryId[0];
					}

					if(response.volume) {
						volume = response.volume || '0';
					}

					if(response.quantity) {
						quantity = response.quantity || '0';
					}

					$.pubsub('publish', 'SHOPCART_UPDATED.add', {
						product: [
							{
								bundleId: bundleId,
								itemId: itemId,
								catEntryId: catEntryReponse,
								name: productNameStr,
								productId: productId,
								volume: volume,
								quantity: quantity
							}
						],
						rewardEligibility: {
							orderId: response.orderId[0],
							rewardOptionEligible: response.rewardOptionEligible,
							rewardsAdded: response.rewardsAdded,
						},
						action: 'add',
						disableMiniCart: disableMiniCart
					});
				}
			} else {
				$.productFormUtil.displayErrorMessage(response.errorMessage, this.productForm);
				$.productFormUtil.setProductGridProductHeights();
			}

		},

		//
		// WISHLIST METHODS
		addToWishList: function(event, eventData){

			if ( DEBUG ) console.log('addToWishList');

			var self = this,
				actionUrl,
				dataObj;

			// prevent default when not called from pubsub event
			if(event.type) {
				event.preventDefault();
				event.currentTarget.blur();
			}

			if (!self.checkAllAttributeSelection()){
				return;
			}

			dataObj   = self.buildDataObjectForValidAddToWishList();
			actionUrl = ctx.getContextRoot() + "VFAjaxInterestItemAdd";

			self.submitForm(dataObj, actionUrl, function(response){

				self.handleWishListAddResponse(response, eventData);

			});

		},

		addToWishListMessaging: function(event){

			$.pubsub('subscribe', 'vfdp.wcs.product_form.add_to_wishlist_message', function(message, data) {

				if( $('.add-to-wishlist-js').attr('data-changed-add-to-wishlist-text') ){
					var formAction = data.formAction;
					var $addToWishListSuccessText = $('.add-to-wishlist-js').attr('data-changed-add-to-wishlist-text');
					var $addToWishListDefaultText = $('.add-to-wishlist-js').attr('data-default-add-to-wishlist-text');

					if (formAction === 'success'){
						// show success button text
						$('.add-to-wishlist-js .wishlist-button-text').text( $addToWishListSuccessText );
						$('.add-to-wishlist-js .icon-check').removeClass('hide');
						$('.add-to-wishlist-js').addClass('success');
					}
					else {
						// revert to default button text;
						$('.add-to-wishlist-js .wishlist-button-text').text( $addToWishListDefaultText );
						$('.add-to-wishlist-js .icon-check').addClass('hide');
						$('.add-to-wishlist-js').removeClass('success');
					}
				}
			});

		},

		buildDataObjectForValidAddToWishList : function () {

			if ( DEBUG ) console.log('buildDataObjectForValidAddToWishList');

			var self 	= this,
				dataObj = {};

			dataObj = {};
			dataObj.storeId 	= self.storeId;
			dataObj.langId 		= self.langId;
			dataObj.catalogId 	= self.catalogId;
			dataObj.catEntryId 	= self.catEntryId;
			dataObj.quantity 	= ( !$.productFormUtil.isValidQuantity(self.productForm) ? 1 : $.productFormUtil.getQuantity(self.productForm));
			dataObj.listId 		= '.';
			dataObj.URL 		= '/';

			// For custom product adding couple of extra params to dataObj.
			unmadeEditorOptions = $('.product-content-form-customise-btn').data('unmadeEditorOptions');
			currentDesignId = unmadeEditorOptions ? unmadeEditorOptions.currentDesignId : null;

			if (currentDesignId) {
				dataObj.extRecipeId = currentDesignId;
				dataObj.imageURL = unmadeEditorOptions ? unmadeEditorOptions.imageUrl : null;
				dataObj.recipeJson = unmadeEditorOptions ? unmadeEditorOptions.recipeJson : null;
				dataObj.listIdName = unmadeEditorOptions ? unmadeEditorOptions.listIdName : null;
			}

			return dataObj;

		},

		initAddToWishListClass: function() {
			var $productActionsPrimary = this.productForm.find('.product-actions-primary');
			var $addToWishlist = $productActionsPrimary.find('.add-to-wishlist-js');
			if($addToWishlist.length > 0) {
				$productActionsPrimary.addClass('add-to-wishlist-enabled');
			}
		},

		initGlobalEvent: function() {
			var self = this;
			if (self.formUpdateEvent) {
				return;
			}
			self.formUpdateEvent =  $.pubsub('subscribe', 'WCS.PRODUCTFORM.COLORWAY_PRODUCT.FORM_UPDATE', function(msg, data){
				self.productForm = data.updatedForm;
				self.initAddToCart();
			});
		},

		addToWishListIconHandle: function() {
			var $addToWishList = $('.add-to-wishlist-js');
			$addToWishList.addClass('add-wishlist-filled');

			if($addToWishList.data('useAnimation')){
				var $addToWishListIcon = $addToWishList.find('.icon-wishlist');
				$addToWishListIcon.removeClass('icon-wishlist').addClass('icon-favorite-filled');

				//Trigger Animation
				$addToWishListIcon.addClass('favorites-icon-filled-animated');
				setTimeout(function () {
					$addToWishListIcon.removeClass('favorites-icon-filled-animated');
				}, 700);
			}
		},

		handleWishListAddResponse : function (response, eventData) {

			if ( DEBUG ) console.log('handleWishListAddResponse -- ', 'response : ', response);

			if(response.listId) {

				if($('.wishlist-js').length > 0) $('.wishlist-js').trigger('click');

				var productFormIndex = $('.product-form-js').index(this.productForm),
					dataProduct = $("#product-info .product-info-js:not(.hide)").data();

				$.pubsub('publish', 'vfdp.wcs.product_form.add_to_wishlist_succeeded',
				{
					productFormIndex: productFormIndex,
					productName: dataProduct.catentryNameDl
				});

                var data = dataExtract.getProductDataTracking();
                var dataWishiList =  dataExtract.getProductData(this.productForm, response);
                $.pubsub('publish','WISHLIST_UPDATED.add', $.extend(true, dataWishiList, data, eventData));

				$.pubsub('publish', 'vfdp.wcs.product_form.add_to_wishlist_message', {formAction: 'success'});
				this.addToWishListIconHandle();


			} else {
				$.productFormUtil.displayErrorMessage(response.errorMessage, this.productForm);
			}

		}
	};

	$.extend(AddToCart.prototype, ProductForm.prototype);

	// prevent duplicate instantiation
	$.fn.AddToCartForm = function(options) {
		return this.each(function() {
			var instance = $(this).data(PLUGIN_IDENTIFIER);
			if(!instance) {
				instance = new AddToCart(this, options).initAddToCart();
				$(this).data(PLUGIN_IDENTIFIER,instance);
			}
		});
	};

});
